var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-container",
    { staticClass: "font-weight-bold", attrs: { fluid: "" } },
    [
      _c(
        "div",
        {
          ref: "controlTableTitle",
          class: _vm.$vuetify.breakpoint.smAndDown
            ? "control-table-title"
            : "pinned-header control-table-title",
          style: _vm.controlTableTitleStyle,
        },
        [
          _c(
            "v-row",
            {
              directives: [
                {
                  name: "resize",
                  rawName: "v-resize",
                  value: _vm.onResize,
                  expression: "onResize",
                },
              ],
            },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { staticClass: "pb-0", attrs: { cols: "12", md: "3" } },
                    [
                      _c("v-card-title", { staticClass: "pb-0" }, [
                        _vm._v("Results View Data"),
                      ]),
                    ],
                    1
                  ),
                  _c("v-spacer"),
                  _c(
                    "v-col",
                    {
                      staticClass: "text-right pl-6 pb-0",
                      attrs: { cols: "3", md: "auto" },
                    },
                    [
                      _c("v-switch", {
                        attrs: { label: "Show Only Unviewed" },
                        model: {
                          value: _vm.displayUnviewedControls,
                          callback: function ($$v) {
                            _vm.displayUnviewedControls = $$v
                          },
                          expression: "displayUnviewedControls",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "text-right pb-0",
                      attrs: { cols: "3", md: "auto" },
                    },
                    [
                      _c("v-switch", {
                        attrs: { label: "Sync Tabs" },
                        model: {
                          value: _vm.syncTabs,
                          callback: function ($$v) {
                            _vm.syncTabs = $$v
                          },
                          expression: "syncTabs",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "text-right pb-0",
                      attrs: { cols: "3", md: "auto" },
                    },
                    [
                      _c("v-switch", {
                        attrs: { label: "Single Expand" },
                        on: { change: _vm.handleToggleSingleExpand },
                        model: {
                          value: _vm.singleExpand,
                          callback: function ($$v) {
                            _vm.singleExpand = $$v
                          },
                          expression: "singleExpand",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "text-right pb-0",
                      attrs: { cols: "3", md: "auto" },
                    },
                    [
                      _c("v-switch", {
                        staticClass: "mr-5",
                        attrs: { label: "Expand All" },
                        model: {
                          value: _vm.expandAll,
                          callback: function ($$v) {
                            _vm.expandAll = $$v
                          },
                          expression: "expandAll",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("ResponsiveRowSwitch", {
            scopedSlots: _vm._u([
              {
                key: "status",
                fn: function () {
                  return [
                    _c("ColumnHeader", {
                      attrs: { text: "Status", sort: _vm.sortStatus },
                      on: {
                        input: function ($event) {
                          return _vm.set_sort("status", $event)
                        },
                      },
                    }),
                  ]
                },
                proxy: true,
              },
              {
                key: "set",
                fn: function () {
                  return [
                    _c("ColumnHeader", {
                      attrs: { text: "Result Set", sort: _vm.sortSet },
                      on: {
                        input: function ($event) {
                          return _vm.set_sort("set", $event)
                        },
                      },
                    }),
                  ]
                },
                proxy: true,
              },
              {
                key: "id",
                fn: function () {
                  return [
                    _c(
                      "v-row",
                      { staticClass: "pa-3" },
                      [
                        _c("ColumnHeader", {
                          attrs: { text: "ID", sort: _vm.sortId },
                          on: {
                            input: function ($event) {
                              return _vm.set_sort("id", $event)
                            },
                          },
                        }),
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u([
                              {
                                key: "activator",
                                fn: function ({ on, attrs }) {
                                  return [
                                    _c(
                                      "v-icon",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            staticClass: "ml-0",
                                            staticStyle: { cursor: "pointer" },
                                            attrs: { small: "" },
                                          },
                                          "v-icon",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [_vm._v("mdi-information-outline")]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          },
                          [
                            _c("span", [
                              _vm._v("ID "),
                              _c("br"),
                              _vm._v("(Legacy ID) "),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "title",
                fn: function () {
                  return [
                    _c("ColumnHeader", {
                      attrs: { text: "Title", sort: "disabled" },
                    }),
                  ]
                },
                proxy: true,
              },
              {
                key: "severity",
                fn: function () {
                  return [
                    _c("ColumnHeader", {
                      attrs: { text: "Severity", sort: _vm.sortSeverity },
                      on: {
                        input: function ($event) {
                          return _vm.set_sort("severity", $event)
                        },
                      },
                    }),
                  ]
                },
                proxy: true,
              },
              {
                key: "tags",
                fn: function () {
                  return [
                    _c("ColumnHeader", {
                      attrs: {
                        text: "800-53 Controls & CCIs",
                        sort: "disabled",
                      },
                    }),
                  ]
                },
                proxy: true,
              },
              {
                key: "runTime",
                fn: function () {
                  return [
                    _c("ColumnHeader", {
                      attrs: { text: "Run Time", sort: _vm.sortRunTime },
                      on: {
                        input: function ($event) {
                          return _vm.set_sort("runTime", $event)
                        },
                      },
                    }),
                  ]
                },
                proxy: true,
              },
              {
                key: "viewed",
                fn: function () {
                  return [
                    _c("ColumnHeader", {
                      attrs: {
                        text: "Controls Viewed",
                        sort: "disabled",
                        "viewed-header": true,
                        "number-of-viewed-controls": _vm.numOfViewed,
                        "number-of-all-controls": _vm.raw_items.length,
                      },
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _vm._l(_vm.items, function (item) {
        return _c(
          "v-lazy",
          {
            key: item.key,
            attrs: { "min-height": "50", transition: "fade-transition" },
          },
          [
            _c(
              "div",
              { attrs: { id: _vm.striptoChars(item.key) } },
              [
                _c("ControlRowHeader", {
                  class: _vm.$vuetify.breakpoint.smAndDown
                    ? ""
                    : "pinned-header",
                  style: _vm.controlRowPinOffset,
                  attrs: {
                    control: item.control,
                    expanded: _vm.expanded.includes(item.key),
                    "viewed-controls": _vm.viewedControlIds,
                  },
                  on: {
                    toggle: function ($event) {
                      return _vm.toggle(item.key)
                    },
                    "control-viewed": _vm.toggleControlViewed,
                  },
                }),
                _vm.expanded.includes(item.key)
                  ? _c("ControlRowDetails", {
                      attrs: {
                        control: item.control,
                        tab: _vm.syncTabs ? _vm.syncTab : undefined,
                      },
                      on: { "update:tab": _vm.updateTab },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }